import { render, staticRenderFns } from "./WorkspaceAdmin.vue?vue&type=template&id=208494c3&"
import script from "./WorkspaceAdmin.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports